import {useClosedSidebar} from "../../shared/hooks/useClosedSdebar";
import {PresenceQrGenerator} from "../../components/PresenceQrGenerator";


export const PresenceQrGeneratorPage = (props: any) => {

  useClosedSidebar();

  return (
    <>
      <div>
        <PresenceQrGenerator {...{ compact: false, show_info: true }} />
      </div>
    </>
  );
};